module.exports = __webpack_public_path__ + "static/media/awaiting_parts_grey.cab9d553.svg";